//@flow
import * as React from 'react'
import Head from 'next/head'
import classnames from 'classnames'

import { Breadcrumbs, Subheading, NotAllowed, Flex, Button } from 'components/common'
import { usePageStyles } from './styles'
import { useGlobalContext } from '~/core/context'
import { useI18n } from '~/core/i18n'
import { checkIframe } from '~/core/utils/functions'

import type { BreadcrumbsLink } from 'components/common/breadcrumbs/breadcrumbs'

type PageProps = {
  title: string,
  children: React.Node,
  breadcrumbs?: BreadcrumbsLink[],
  subheading?: string,
  className?: string,
  paidModule?: string,
  isReadable?: boolean,
  [key: string]: any
}

const Page = ({
  title,
  breadcrumbs,
  subheading,
  children,
  className,
  isReadable = true,
  paidModule,
  ...props
}: PageProps) => {
  const classes = usePageStyles()
  const { pbx } = useGlobalContext()
  const [msg] = useI18n()
  const isIframe = checkIframe()

  if (paidModule && pbx.modules[paidModule] !== true) {
    return (
      <NotAllowed
        TextComponent={
          <Flex column>
            <span>{msg('common.errors.paidModuleNoAccess')}</span>
          </Flex>
        }
      />
    )
  }

  if (!isReadable) {
    return <NotAllowed TextComponent={msg('common.errors.notAllowedAccess')} />
  }

  return (
    <section className={classnames(classes.pageWrapper, className)} {...props}>
      <Head>
        <title>{title}</title>
      </Head>
      {!isIframe && (
        <>
          {breadcrumbs && <Breadcrumbs links={breadcrumbs} />}
          {subheading && <Subheading>{subheading}</Subheading>}
        </>
      )}
      {children}
    </section>
  )
}

export { Page }
